import { useQuery } from '@tanstack/react-query';
import { trackingService } from '@/services/tracking.service';
import { retryUnlessSetupError, trackerKeys, TRACKER_LIVE_INTERVAL_MS } from './trackerQuery';

export function useTrackerUsers(live: boolean, enabled = true) {
  return useQuery({
    queryKey: trackerKeys.users,
    queryFn: () => trackingService.users(),
    refetchInterval: live ? TRACKER_LIVE_INTERVAL_MS : false,
    retry: retryUnlessSetupError,
    enabled,
  });
}
